import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_settlement_method_adjustment_RowInterface, bl_fi_generic_doc_settlement_method_adjustment_RowClass } from "../../dbschema";

export class GenericDocSettlementMethodContainerAdjustmentModel extends BaseContainerModel {
  bl_fi_generic_doc_settlement_method_adjustment: bl_fi_generic_doc_settlement_method_adjustment_RowInterface = new bl_fi_generic_doc_settlement_method_adjustment_RowClass();
}
